import { Icons } from '@/app/components/ui/Icons'
import { FC } from 'react'

export interface Props {
	count: number
	className?: string
	size?: number
}

const Stars: FC<Props> = ({ count, className, size = 12 }) => {
	return (
		<div
			data-test-id="stars-component"
			data-stars={count}
			className={className}
		>
			{new Array(count).fill(0).map((_, i) => {
				return <Icons.star key={i} width="16" height="16" fill="#003E74" />
			})}
		</div>
	)
}

export default Stars
